import React, {useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import ReleaseFormIn from "../components/ReleaseFormIn"
import ReleaseFormInEdit from "../components/ReleaseFormInEdit";
import ReleaseFormOut from "../components/ReleaseFormOut";
import {useFetching} from "../hooks/useFetching";
import $api from "../http";
import Loader from "../components/UI/Loader/Loader";
import ReleaseFormView from "../components/ReleaseFormView";
import {Context} from "../index";
import Alert from "react-bootstrap/Alert";

const ViewRelease = () => {
    const {store} = useContext(Context);
    const {id} = useParams();

    const [release, setRelease] = useState(null);
    const [fetchRelease, isReleaseLoading, fetchError] = useFetching(async () => {
        const response = await $api.get(`/release/getById/${id}`)
        const loadedRelease = response.data.release;

        setRelease({
            ...loadedRelease,
            containers: Array.isArray(loadedRelease?.containers) ? loadedRelease.containers : [],
            cars: Array.isArray(loadedRelease?.cars) ? loadedRelease.cars : [],
        });

    })
    useEffect(() => {
        fetchRelease()
    }, [])


    if(fetchError){
        return(
            <Alert variant="danger" className="my-5">
                Не удалось загрузить заявку. Обновите страницу или обратитесь к менеджеру.
            </Alert>
        )
    }
    if(isReleaseLoading || !release){
        return(
         <Loader/>
        )
    }
    return <ReleaseFormView release={release} currency={store.currency}/>;
};

export default ViewRelease;
